module.exports = require('./RadialProgressBar.vue')



//////////////////
// WEBPACK FOOTER
// ./~/vue-radial-progress/src/main.js
// module id = 398
// module chunks = 0